import { MobilePermissionEnum } from 'constants-permissions';
import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const HIDDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.HID,
  hasCustomUI: true,
  friendlyName: 'HID Access Control',
  description: `Defines the properties required for an HID integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    supportPage: {
      friendlyName: 'Support Page',
      type: 'Content',
    },
  },
  mobilePermissions: [
    MobilePermissionEnum.Bluetooth,
    MobilePermissionEnum.SecureDevice,
  ],
  // Google requires us to use specific language requesting background location access before we load the system prompts
  mobilePermissionsRequest:
    'To unlock doors, Workplace Access requires these device settings to be enabled, including accessing your location when the application is not in use:',
};

/**
 * @deprecated Use `HIDDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { HIDDefinition} from 'application-types';`
 */
export default HIDDefinition;
